import React from "react";
import Select from 'react-select';


export const inputField = ({ input, label, type, className, placeholder,id, fieldValue,style,meta: { touched, error } }) => (
        <div>
            <input {...input} style={style}  type={type} value={fieldValue} placeholder={placeholder} className={className} id={id} />
            {touched && ((error && <span style={{color: "red"}} className="form-error is-visible">{error}</span>) )}
        </div>

);

export const textAreaField = ({ input, label, rows, cols, type, id, fieldValue, className, meta: { touched, error } }) => (
    <div>
        <textarea {...input} rows={rows} cols={cols} className={className} id={id} />
            {touched && ((error && <span style={{color: "red"}} className="form-error is-visible">{error}</span>) )}
    </div>

);

export const selectField = ({ input, value, valueKey, name, options, id, placeholder, simpleValue, meta: { touched, error }, ...field }) => (
    <div>
        <Select
            {...input}
            {...field}
            id={id}
            name={name}
            defaultValue={input.value}
            valueKey={valueKey}
            options={options}
            value={(input.value) ? input.value : input.selectedValue}
            placeholder={placeholder}
            onBlur={() => input.onBlur(value)}
            onChange={(value) => { input.onChange(value)} }
        />
        <div>{touched && ((error && <span style={{color: "red"}} className="form-error is-visible">{error}</span>) )}</div>
    </div>
);